var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExample(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_96_6148)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.424316,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#F2EEE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 80.4243L81.5 0.424316",
    stroke: "#321A03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 1.42432L80.5 80.4243",
    stroke: "#321A03"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_96_6148"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.424316,
    width: 80,
    height: 80,
    rx: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExample);
export default __webpack_public_path__ + "static/media/icon-example.4e6aeed2d33683c307071d2101d33db1.svg";
export { ForwardRef as ReactComponent };